import projects from "../views/projects.vue";
import Home from "../views/Home.vue";
import docs from "../views/docs.vue";
import login from "../views/login.vue";
import register from "../views/register.vue";
import dashboard from "../views/dashboard.vue";
import project from "../views/project.vue";
import userProfile from "../views/userProfile.vue";
import forgotPassword from "../views/forgotPassword.vue";
import changePassword from "../views/changePassword.vue";

// Routes
const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/docs",
    name: "docs",
    component: docs
  },
  {
    path: "/projects",
    name: "projects",
    component: projects
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/register",
    name: "register",
    component: register
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard
  },
  {
    path: "/project/:id",
    name: "project",
    component: project
  },
  {
    path: "/userProfile/:id",
    name: "userProfile",
    component: userProfile
  },
  {
    path: "/forgotPassword/",
    name: "forgotPassword",
    component: forgotPassword
  },
  {
    path: "/changePassword/:id",
    name: "changePassword",
    component: changePassword
  }
];

// Export routes
export default routes;